import React, { Component } from 'react';
import "./Currency.js";
import {getColumnCheck} from "./Client_Currency.js";

export class Column extends Component{
  render() {
    var header,client_id,style, config, visible = false;
    header = this.props.header;
    client_id = this.props.client_id;
    config = this.props.config;
    style={'background-color':'#ededed'};
    if (getColumnCheck(client_id,header,config)) visible = true
    return (
       visible &&
       (<span className="form-control" style={style}>
        <i className="fa fa-dollar-sign fa-fw">
        </i>{header}
      </span>)
    );
  }
};

export class Row extends Component{
  render() {
    var header, rate_list, currency, visible = false;
    header = this.props.header;
    rate_list = this.props.rate_list;
    currency = this.props.from;
    if (currency && rate_list) {
      if (rate_list[currency] && rate_list[currency] !== 'None') visible = true;
    }else if (header === 'Currency') visible = true;

    return (
      visible &&
      (<span className="input-group-addon">
        <i className="fa fa-dollar-sign fa-fw">
        </i>{header}
      </span>)
    );
  }
};
